import classNames from 'classnames';
import i18next from 'i18next';
import { Link } from 'react-router-dom';
import { Container, List } from 'yoso';
import { useRemoteSearchComponent } from '~/components/Dosi/Remote/Remote.hooks';
import { useHeaderTheme, useTransition } from '~/components/Header/Header.hooks';
import styles from '~/components/Header/Header.module.scss';
import { Logo } from '~/components/Icon';
import { DosiLogo } from '~/components/Icon/DosiLogo';
import { BackButton } from '~/components/Route/Button/BackButton';
import { SidebarButton } from '~/components/Sidebar/Button/SidebarButton';
import appStyles from './DosiAppHeader.module.scss';

export const DosiAppHeader = () => {
  const { dark, blur } = useHeaderTheme();
  const transition = useTransition();

  return (
    <div
      className={classNames('header', styles.root, {
        [styles.dark]: dark,
        [styles.blur]: blur,
        [styles.transition]: transition,
      })}>
      <div className={styles.inner}>
        <BackButton
          className={classNames(styles.button, appStyles.backButton)}
          data-event="click"
          data-event-target="gnb_back"
        />
        <Link className={appStyles.logoLink} to="/" data-event="click" data-event-target="gnb_logo">
          <Logo className={styles.logo} display="block" />
        </Link>
        <List className={styles.right}>
          <li>
            <a
              className={styles.link}
              data-event="click"
              data-event-target="gnb_dosi"
              href={import.meta.env.VITE_DOSI_URL}>
              <DosiLogo />
            </a>
          </li>
          <li
            ref={useRemoteSearchComponent({
              lang: i18next.resolvedLanguage,
              brandId: 1,
              className: styles.remoteSearch,
              'data-event': 'click',
              'data-event-target': 'gnb_search',
            })}
          />
          <li>
            <SidebarButton
              variant="text"
              className={styles.sidebarButton}
              data-event="click"
              data-event-target="sidebar_menu"
            />
          </li>
        </List>
      </div>
      <Container id="header-portal" margin="auto" />
    </div>
  );
};
